module.exports = __webpack_public_path__ + "img/img55.fe164414.svg";